import { Web2PublishTemplatesByTagAndCat } from 'components/Web2Publish/components/TemplatesByTagAndCat';

const ScreenWeb2PublishTemplatesByTagAndCat = () => {
  return <Web2PublishTemplatesByTagAndCat />;
};

export default ScreenWeb2PublishTemplatesByTagAndCat;
